const baseStyle = {
  borderColor: 'brand.primary.base'
}

export const Spinner = {
  baseStyle,
  sizes: {
    lg: {
      borderWidth: '3px'
    },
    xl: {
      borderWidth: '4px'
    }
  }
}
